import React from "react";
import { Button } from "@mui/material";
import DirectionsIcon from "@mui/icons-material/Directions";

const MapDirectionButton = ({ latitude, longitude }) => {
  if (!latitude || !longitude) {
    return null; // render nothing if coords are missing
  }

  const destination = `${latitude},${longitude}`;
  const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=current+location&destination=${destination}`;

  return (
    <Button
      component="a"
      href={mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      size="small"
      variant="outlined"
      color="success"
      startIcon={<DirectionsIcon />}
    >
      Directions
    </Button>
  );
};

export default MapDirectionButton;
// --- IGNORE ---